import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, DownloadIcon } from '@umanforge/common';
import { InfoIcon } from 'components/icons/info_icon.component';
import { InfoModal } from 'components/modals/info_modal.component';

interface ImportHelperModalProps {
  api: () => Promise<unknown> | unknown;
  text: React.ReactNode;
  title?: string;
  buttonLabel?: string;
  buttonIcon?: React.ReactNode;
  triggerAriaLabel?: string;
}

export const ImportHelperModal: React.FC<ImportHelperModalProps> = ( {
  api,
  text,
  title,
  buttonLabel,
  buttonIcon,
  triggerAriaLabel,
} ) => {
  const { t } = useTranslation();
  const [ isOpen, setIsOpen ] = useState( false );

  return (
    <>
      <button
        type='button'
        className='flex items-center justify-center rounded-full hover:bg-gray-100 p-1'
        aria-label={ triggerAriaLabel ?? 'info' }
        onClick={ () => { setIsOpen( true ); } }
      >
        <InfoIcon className='w-5 h-5 text-blue-600 cursor-pointer' size={ 20 } />
      </button>

      <InfoModal
        title={ title ?? t( 'import_help_title' ) }
        isOpen={ isOpen }
        onClose={ () => { setIsOpen( false ); } }
      >
        <div className='flex flex-col gap-4 p-4 min-w-[360px] max-w-[480px]'>
          <div className='text-sm text-gray-700'>
            { text }
          </div>

          <Button
            label={ buttonLabel ?? t( 'download_template' ) }
            className='w-full m-1 bg-[#0BB173] hover:bg-[#088D5C] hover:ring-1 hover:ring-[#088D5C] text-sm font-medium text-white'
            icon={ buttonIcon ?? <DownloadIcon className='w-[24px] h-[24px] p-0.5 text-white' /> }
            onClick={ async () => {
              await api();
              setIsOpen( false );
            } }
          />
        </div>
      </InfoModal>
    </>
  );
};
